import { HttpClient } from '../../protocols/http/httpClient'
import { Contract, IUpdateContracts } from '../../../domain/usecases/Contracts'
import { validateHttpStatus } from '../../../validation/validateHttpResponse'
import { Contract as ContracType } from '../../../domain/models/ContractsModel'
import moment from 'moment'

export class RemoteUpdateContract implements IUpdateContracts {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}

  @validateHttpStatus
  // async updateOne(params: Contract.UpdateParams): Promise<any> {
  async updateOne(params: any): Promise<any> {
    const {
      id,
      cpfOrCnpjList,
      business_name,
      created_id,
      custom_contract_file,
      attachment_files,
      attachment_ids_to_keep,
      buyers = [],
      payment_parts = [],
      deadline_allows_modify_unit,
      ...properties
    } = params

    const formData = new FormData()

    // Add custom contract file if provided
    if (custom_contract_file) {
      formData.append('custom_contract_file', custom_contract_file)
    }

    // Add new attachment files if provided
    if (attachment_files && attachment_files.length > 0) {
      for (let i = 0; i < attachment_files.length; i++) {
        formData.append('attachment_files', attachment_files[i])
      }
    }

    // Add attachment IDs to keep (existing attachments that should NOT be deleted)
    if (attachment_ids_to_keep && attachment_ids_to_keep.length > 0) {
      // Send as comma-separated string for easier backend parsing
      formData.append(
        'attachment_ids_to_keep',
        attachment_ids_to_keep.join(',')
      )
    }

    // Add buyers
    for (let i = 0; i < buyers.length; i++) {
      formData.append(`buyers[${i}]`, buyers[i])
    }

    // Add deadline
    if (deadline_allows_modify_unit) {
      formData.append(
        'deadline_allows_modify_unit',
        moment(deadline_allows_modify_unit).toISOString()
      )
    }

    // Add payment parts
    for (let i = 0; i < payment_parts.length; i++) {
      formData.append(
        `payment_parts[${i}][first_due_date]`,
        moment(payment_parts[i].first_due_date).toISOString()
      )
      formData.append(
        `payment_parts[${i}][frequency]`,
        payment_parts[i].frequency
      )
      formData.append(
        `payment_parts[${i}][installment_value]`,
        payment_parts[i].installment_value.toString()
      )
      formData.append(
        `payment_parts[${i}][installments]`,
        payment_parts[i].installments.toString()
      )
      formData.append(`payment_parts[${i}][name]`, payment_parts[i].name)
      formData.append(
        `payment_parts[${i}][total_value]`,
        payment_parts[i].total_value.toString()
      )
    }

    // Add remaining properties
    const props: Record<string, any> = properties
    for (const key in props) {
      if (typeof props[key] === 'object' && props[key] !== null) {
        for (const subKey in props[key]) {
          formData.append(`${key}[${subKey}]`, props[key][subKey])
        }
      } else if (props[key] !== null && props[key] !== undefined) {
        formData.append(key, props[key])
      }
    }

    return await this.httpClient.patch?.({
      url: `${this.url}/contracts/${id}`,
      data: formData,
      headers: {
        Accept: '*/*'
      }
    })
  }

  private formateDataToBackend(params: Contract.UpdateParams) {}

  @validateHttpStatus
  async createOne(params: Contract.CreateParams): Promise<ContracType> {
    const {
      buyers = [],
      payment_parts = [],
      custom_contract_file,
      deadline_allows_modify_unit,
      ...properties
    } = params
    const formData = new FormData()
    formData.append(`custom_contract_file`, custom_contract_file!)

    for (let i = 0; i < buyers.length; i++) {
      formData.append(`buyers[${i}]`, buyers[i])
    }

    formData.append(
      `deadline_allows_modify_unit`,
      moment(deadline_allows_modify_unit).toISOString()
    )

    for (let i = 0; i < payment_parts.length; i++) {
      formData.append(
        `payment_parts[${i}][first_due_date]`,
        moment(payment_parts[i].first_due_date).toISOString()
      )
      formData.append(
        `payment_parts[${i}][frequency]`,
        payment_parts[i].frequency
      )
      formData.append(
        `payment_parts[${i}][installment_value]`,
        payment_parts[i].installment_value.toString()
      )
      formData.append(
        `payment_parts[${i}][installments]`,
        payment_parts[i].installments.toString()
      )
      formData.append(`payment_parts[${i}][name]`, payment_parts[i].name)
      formData.append(
        `payment_parts[${i}][total_value]`,
        payment_parts[i].total_value.toString()
      )
    }

    const props: Record<string, any> = properties
    for (const key in props) {
      if (typeof props[key] === 'object') {
        for (const subKey in props[key]) {
          formData.append(`${key}[${subKey}]`, props[key][subKey])
        }
      } else {
        formData.append(key, props[key])
      }
    }

    return await this.httpClient.post?.({
      url: `${this.url}/contracts/`,
      data: formData,
      headers: {
        Accept: '*/*'
      }
    })
  }
}
